// extracted by mini-css-extract-plugin
export default {"wrapper":"_GYMjKuNCzJOUK_jFirvm","prevData":"PfaMTfBxd76mC5wvqH-dv","prevDataValue":"_3CciHWHLrVEUG6xoAYykZg","dotIndicator":"_2Dij-joKieVe8-VVzf95qk"};